<template>
  <div id="July2023" class="202306">
    <div class="fixed z-50 hidden xl:block" :class="{ 'fixed-btn': isMenu, 'hidden-btn': !isMenu}">
      <a class="toggle-btn absolute cursor-pointer p-6 block" @click="isMenu = !isMenu">
        <img src="~@/assets/images/202307/menu/right.png" class="object-contain w-full">
      </a>
      <a class="block px-3 cursor-pointer" @click="toTop('#section2')"><img src="~@/assets/images/202307/menu/menu-off_01.png" class="object-contain"></a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#section3')">
        <img src="~@/assets/images/202307/menu/menu-on_02.png" class="off object-contain">
        <img src="~@/assets/images/202307/menu/menu-off_02.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop('#July2023')">
        <img src="~@/assets/images/202307/menu/menu-on_03.png" class="off object-contain">
        <img src="~@/assets/images/202307/menu/menu-off_03.png" class="on object-contain">
      </a>
    </div>
    <main class="main mx-auto">
      <section id="section1" class="section1 pt-16 pb-64">
        <div class="flex justify-center w-full mb-6 container px-2">
          <div><img src="~@/assets/images/202307/Master Vision.png" class="object-contain block"></div>
        </div>
        <div class="flex flex-col lg:flex-row items-center justify-center container px-2">
          <div class="hidden md:block"><img src="~@/assets/images/202307/Program block.png" class="object-contain block"></div>
          <div class="md:hidden mb-2"><img src="~@/assets/images/202307/m/A.png" class="object-contain block"></div>
          <div class="md:hidden mb-2"><img src="~@/assets/images/202307/m/B.png" class="object-contain block"></div>
          <div class="md:hidden"><img src="~@/assets/images/202307/m/C.png" class="object-contain block"></div>
        </div>
      </section>

      <section id="section2" class="section2 py-8 md:pb-40 -mt-48 relative px-2">
        <div class="flower1 absolute bottom-0 right-0 z-10">
          <img src="~@/assets/images/202307/right_leaf.png" class="object-contain block m-0">
        </div>
        <div class="flower2 absolute bottom-0 left-0 z-10 w-1/3 md:w-auto">
          <img src="~@/assets/images/202307/left_leaf.png" class="object-contain block m-0">
        </div>

        <div class="container bg-white relative" style="border-radius: 25px; border: 3px solid #012861;">
          <div class="absolute top-0 left-0 md:block w-1/5 lg:w-auto">
            <img src="~@/assets/images/202307/plan-a-corn.png" class="object-contain block m-0">
          </div>
          <div class="w-full flex justify-center py-10">
            <img src="~@/assets/images/202307/plan.A-title.png" class="object-contain block m-0 w-3/5">
          </div>
          <div class="flex flex-wrap w-full p-5 lg:p-8" v-if="renderComponent">
            <router-link :to="{ name: 'detail', params: { category: 'magazine', id: item.id } }" class="p-2 lg:p-5 w-1/2 md:w-1/4 block" v-for="(item, index) in planData" :key="index">
              <div class="mb-6">
                <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block book-shadow book-border"  v-if="!item.cover">
                <img v-lazy="`https://api.liveabc.com/v1/product_categories/${item.category_id}/cover`" class="book-border w-full h-full object-contain block book-shadow" v-else>
              </div>

              <p class="text-2xl font-black text-center text-main-color">{{ item.title }}</p>
              <p class="mb-1 text-center text-main-color text-xs lg:text-base">{{ item.grade }}</p>

              <div class="w-full justify-center flex mt-5">
                <a href="" class="main-blue-bg px-5 py-3 inline-block mx-auto rounded-full" style="color: #FFF21F;">立即訂閱 ＞</a>
              </div>

            </router-link>
            <div class="pt-2 pl-2 lg:pt-5 lg:pl-5 w-full md:w-1/2">
              <div class="main-blue-bg pb-10 pl-2">
                <img src="~@/assets/images/202307/magazine-order-info.png" class="object-contain block">
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="section3" class="section3 pt-6">
        <div class="w-full flex justify-center mb-8 lg:hidden">
            <img src="~@/assets/images/202307/m/M-3year-bar.png" class="object-contain inline-block">
          </div>
        <div class="main relative px-2 pt-12">
          <div class="w-full justify-center mb-8 hidden lg:flex">
            <img src="~@/assets/images/202307/3year-bar.png" class="object-contain" style="margin-top: -10rem;">
          </div>
          <div class="container bg-white relative z-10 px-5 content">
            <div class="absolute top-0 left-0 w-1/5 lg:w-auto">
              <img src="~@/assets/images/202307/plan-b-corn.png" class="object-contain block m-0">
            </div>
            <div class="w-full flex justify-center py-10">
              <img src="~@/assets/images/202307/plan.B-title.png" class="object-contain block m-0 w-3/5">
            </div>
            <div class="flex flex-wrap container py-5 lg:p-8" style="border-bottom: 3px dashed #012861;">
              <div class="item w-1/2 md:w-1/4 p-2 lg:p-4">
                <img src="~@/assets/images/202307/1-images-tt.png" class="object-contain block m-0">
              </div>
              <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="item w-1/2 md:w-1/4 p-2 lg:p-4 cursor-pointer" v-for="(item, idx) in bookData" :key="idx">

                <div class="h-full flex flex-col justify-between mb-3" v-if="renderComponent">
                  <div class="item mb-4 md:rounded">
                    <div class="mx-auto border-0 w-full h-full mb-2">
                      <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!item.img_url">
                      <img v-lazy="item.img_url" class="object-contain block book-shadow book-border" v-else>
                    </div>
                  </div>

                  <div class="price event_text tracking-wider font-semibold flex flex-col justify-between">
                    <p class="font-semibold text-sm md:text-base  text-main-color mb-4">{{ item.name }}</p>
                    <p><span class="text-white font-semibold rounded-md px-2 py-1 mr-2 main-red-orange">69折</span><span class="text-sm lg:text-2xl text-main-color">{{ Math.round(Number.parseFloat(item.fixed_price * 0.69).toFixed(1)) }}元</span></p>
                  </div>
                </div>
              </router-link>
            </div>

            <div class="flex flex-wrap container py-5 lg:p-8"  style="border-bottom: 3px dashed #012861;">
              <div class="item w-1/2 md:w-1/4 p-2 lg:p-4">
                <img src="~@/assets/images/202307/2-images-tt.png" class="object-contain block m-0">
              </div>
              <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="item w-1/2 md:w-1/4 p-2 lg:p-4 cursor-pointer" v-for="(item, idx) in bookData2" :key="idx">

                <div class="h-full flex flex-col justify-between mb-3" v-if="renderComponent">
                  <div class="item mb-4 md:rounded">
                    <div class="mx-auto border-0 w-full h-full mb-2">
                      <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!item.img_url">
                      <img v-lazy="item.img_url" class="object-contain block book-shadow book-border" v-else>
                    </div>
                  </div>

                  <div class="price event_text tracking-wider font-semibold flex flex-col justify-between">
                    <p class="font-semibold text-sm md:text-base text-main-color mb-4">{{ item.name }}</p>
                    <p><span class="text-white font-semibold rounded-md px-2 py-1 mr-2 main-red-orange">69折</span><span class="text-sm lg:text-2xl text-main-color">{{ Math.round(Number.parseFloat(item.fixed_price * 0.69).toFixed(1)) }}元</span></p>
                  </div>
                </div>
                </router-link>
            </div>

            <div class="flex flex-wrap container py-5 lg:p-8">
              <div class="item w-1/2 md:w-1/4 p-2 lg:p-4">
                <img src="~@/assets/images/202307/3-images-tt.png" class="object-contain block m-0">
              </div>
              <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="item w-1/2 md:w-1/4 p-2 lg:p-4 cursor-pointer" v-for="(item, idx) in bookData3" :key="idx">

                <div class="h-full flex flex-col justify-between mb-3" v-if="renderComponent">
                  <div class="item mb-4 md:rounded">
                    <div class="mx-auto border-0 w-full h-full mb-2">
                      <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!item.img_url">
                      <img v-lazy="item.img_url" class="object-contain block book-shadow book-border" v-else>
                    </div>
                  </div>

                  <div class="price event_text tracking-wider font-semibold flex flex-col justify-between">
                    <p class="font-semibold text-sm md:text-base text-main-color mb-4">{{ item.name }}</p>
                    <p><span class="text-white font-semibold rounded-md px-2 py-1 mr-2 main-red-orange">69折</span><span class="text-sm lg:text-2xl text-main-color">{{ Math.round(Number.parseFloat(item.fixed_price * 0.69).toFixed(1)) }}元</span></p>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>

      </section>

      <section id="section4" class="section4 px-2">
        <div class="container bg-white relative z-10 px-5 content">
          <div class="flex flex-wrap container py-5 lg:p-8">
            <div class="item w-1/2 md:w-1/4 p-2 lg:p-4">
              <img src="~@/assets/images/202307/4-images-tt.png" class="object-contain block m-0">
            </div>
            <router-link :to="{ name: 'detail', params: { category: 'book', id: item.id } }" class="item w-1/2 md:w-1/4 p-2 lg:p-4 cursor-pointer" v-for="(item, idx) in bookData4" :key="idx">

              <div class="h-full flex flex-col justify-between mb-3" v-if="renderComponent">
                <div class="item mb-4 md:rounded">
                    <div class="mx-auto border-0 w-full h-full mb-2">
                      <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!item.img_url">
                      <img v-lazy="item.img_url" class="object-contain block book-shadow book-border" v-else>
                    </div>
                  </div>

                <div class="price event_text tracking-wider font-semibold flex flex-col justify-between">
                  <p class="font-semibold text-sm md:text-base  text-main-color mb-4">{{ item.name }}</p>
                  <p><span class="text-white font-semibold rounded-md px-2 py-1 mr-2 main-red-orange">69折</span><span class="text-sm lg:text-2xl text-main-color">{{ Math.round(Number.parseFloat(item.fixed_price * 0.69).toFixed(1)) }}元</span></p>
                </div>
              </div>
            </router-link>
          </div>
        </div>

        <div class="flex justify-center w-full mt-12 z-10">
          <router-link :to="{ name: 'index' }" style="background: #FF663F;" class="text-white py-4 px-5 rounded-full inline-block z-10">更多優惠都在LiveABC官網 ＞</router-link>
        </div>
      </section>

      <section class="footer py-10 main-text-color text-shadow container">
        <div class="container px-4 pl-8">
          <h6 class="text-xl lg:text-2xl mb-4 font-semibold">注意事項</h6>
          <ul class="list-decimal list-outside leading-loose text-base">
            <li>2023.7.1~2023.9.30於LiveABC官方網站訂閱雜誌，訂單成立後即符合「訂就抽獎學金$6666」活動，單筆訂單可參與當月抽獎乙次（以訂單編號為主）。每月將抽出1名中獎者，於次月15日前公告於LiveABC官方網站及官方臉書粉絲團。</li>
            <li>活動期間產生之訂單取消、退貨、交易失敗等條件，將失去參與本活動之資格，不予另行通知。</li>
            <li>活動內容以LiveABC官網發布為主。本公司保留活動修改、變更之權利。</li>
            <li>活動以官網公告為主，凡有變更則不另加通知。</li>
          </ul>
        </div>
      </section>
    </main>
  </div>
</template>
<script>
import jump from 'jump.js'
import axios from 'axios'
export default {
  name: 'May2023',
  metaInfo () {
    return {
      title: '學霸養成！訂雜誌每月抽現金6666💰LiveABC年中折扣季',
      titleTemplate: null
    }
  },
  data () {
    return {
      isMenu: false,
      renderComponent: false,
      planData: [
        { name: 'ABC', id: 8635, grade: '初級｜基礎｜活用', title: 'ABC互動英語', type: 'abc', img_url: require('@/assets/images/202306/ABC-COVER.png') },
        { name: 'LIVE', id: 8637, grade: '中級｜生活｜實用', title: 'Live互動英語', img_url: require('@/assets/images/202306/Live-COVER.png') },
        { name: 'ALL', id: 8638, grade: '中高級｜進階｜應用', title: 'ALL+互動英語', img_url: require('@/assets/images/202306/ALL-COVER.png') },
        { name: 'CNN', id: 8639, grade: '新聞｜時事｜新知', title: 'CNN互動英語', type: 'cnn', img_url: require('@/assets/images/202306/CNN-COVER.png') },
        { name: 'JP', id: 8641, grade: '初級｜生活｜實用', title: '互動日本語', type: 'jp', img_url: require('@/assets/images/202306/JP-COVER.png') },
        { name: 'HW', id: 8640, grade: '圖解｜百科｜符合108課綱', title: '知識大圖解', type: 'hiw', img_url: require('@/assets/images/202306/HIW-COVER.png') }
      ],

      bookData: [
        { id: 8134, text: '小學生必備英語圖解字典', img_url: require('@/assets/images/202307/1-8134.png') },
        { id: 7458, text: 'Kids互動英語 No.5', img_url: require('@/assets/images/202307/1-7458.png') },
        { id: 6373, text: '一看就會圖解英語發音(全新增修版)', img_url: require('@/assets/images/202307/1-6373.png') },
        { id: 8286, text: '小學生必讀品格故事英語繪本 Level 1', img_url: require('@/assets/images/202307/1-8286.png') },
        { id: 8167, text: 'How It Works知識大圖解奇妙大自然大圖解(全新增修版)', img_url: require('@/assets/images/202307/1-8587.png') },
        { id: 8587, text: 'How It Works知識大圖解當代科技大圖解(全新增修版)', img_url: require('@/assets/images/202307/1-8167.png') },
        { id: 1704, text: 'ABC英語故事袋床邊故事篇', img_url: require('@/assets/images/202307/1-1704.png') }
      ],
      bookData2: [
        { id: 8502, text: '多益達人教你應考秘技', img_url: require('@/assets/images/202307/2-8502.png') },
        { id: 8506, text: '提升英語聽力的高效訓練', img_url: require('@/assets/images/202307/2-8506.png') },
        { id: 8588, text: '用心智圖聰明背單字', img_url: require('@/assets/images/202307/2-8588.png') },
        { id: 8463, text: '剖析多益解題關鍵', img_url: require('@/assets/images/202307/2-8463.png') },
        { id: 7964, text: '用英語表達想法及提案', img_url: require('@/assets/images/202307/2-7964.png') },
        { id: 6398, text: '各種通訊往來的英語都在', img_url: require('@/assets/images/202307/2-6398.png') },
        { id: 7847, text: '精通職場情境的關鍵用語', img_url: require('@/assets/images/202307/2-7847.png') }
      ],
      bookData3: [
        { id: 7848, text: '多益必考單字全都背起來', img_url: require('@/assets/images/202307/3-7848.png') },
        { id: 7686, text: '快速Get新聞重點單字', img_url: require('@/assets/images/202307/3-7686.png') },
        { id: 7218, text: '閱讀是英語學習的基礎', img_url: require('@/assets/images/202307/3-7218.png') },
        { id: 8572, text: '網路社群用語快學起來', img_url: require('@/assets/images/202307/3-8572.png') },
        { id: 7874, text: '理解英語片語用法', img_url: require('@/assets/images/202307/3-7874.jpg') },
        { id: 6614, text: '生活中最常見的字彙百科', img_url: require('@/assets/images/202307/3-6614.png') },
        { id: 6681, text: '收錄最想學的日語會話', img_url: require('@/assets/images/202307/3-6681.png') }
      ],
      bookData4: [
        { id: 7456, text: '多益達人教你應考秘技', img_url: require('@/assets/images/202307/4-7456.png') },
        { id: 8150, text: '提升英語聽力的高效訓練', img_url: require('@/assets/images/202307/4-8150.png') },
        { id: 8465, text: '用心智圖聰明背單字', img_url: require('@/assets/images/202307/4-8465.png') },
        { id: 8627, text: '剖析多益解題關鍵', img_url: require('@/assets/images/202307/4-8627.png') },
        { id: 8158, text: '用英語表達想法及提案', img_url: require('@/assets/images/202307/4-8158.png') },
        { id: 8009, text: '各種通訊往來的英語都在', img_url: require('@/assets/images/202307/4-8009.png') },
        { id: 8214, text: '精通職場情境的關鍵用語', img_url: require('@/assets/images/202307/4-8214.png') }
      ]
    }
  },
  mounted () {
    this.getEvent()
  },
  methods: {
    async getEvent () {
      let self = this
      await self.getData(self.planData)
      await self.getData(self.bookData)
      await self.getData(self.bookData2)
      await self.getData(self.bookData3)
      await self.getData(self.bookData4)
    },
    getData (itemData) {
      let self = this
      let pathArr = []
      for (let i = 0; i < itemData.length; i++) {
        pathArr.push(itemData[i].id)
      }
      axios.get(`/products?list=${pathArr.toString()}&pageSize=20`)
        .then((response) => {
          response.data.data.map(item1 => {
            itemData.map(item2 => {
              if (item1.id === item2.id) {
                return Object.assign(item2, item1)
              }
            })
          })
        })
        .then(() => {
          self.forceRerender()
        })
    },
    forceRerender () {
      this.renderComponent = false
      this.$nextTick(() => {
        this.renderComponent = true
      })
    },
    toTop (n) {
      jump(`${n}`, {
        duration: 500,
        offset: 0
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#July2023 {
  .max-w-july {
    max-width: 2040px;
  }
  .main-blue-bg {
    background: #012861;
  }
  .main-red-orange {
    background: #FE663F;
  }
  .text-main-color {
    color: #012861;
  }
  .book-shadow {
    filter: drop-shadow(10px 10px 1px rgba(0, 0, 0, 0.25));
  }
  .book-border {
    border: 1px solid #012861;
  }
  .event_text {
    height: 125px;
  }
  .topBg {
    height: 44px;
    width: 100%;
    background-image: url('~@/assets/images/202306/TOP2.png');
    background-repeat: repeat-x;
    @media (max-width: 640px) {
      background-size: 92px;
      height: 40px;
    }
  }
  .circle {
    left: 5%;
    top: 0;
    width: auto;
    @media (max-width: 1024px) {
      left: 3%;
      top: -17%;
      width: 80%;
    }
    @media (max-width: 996px) {
      left: 0%;
      top: -17%;
      width: 70%;
    }
    @media (max-width: 767px) {
      left: 5%;
      top: -17%;
      width: auto;
    }
  }
  .toggle-btn {
    top: 20%;
    left: -40%;
  }
  .fixed-btn {
    top: 50%;
    transform: translateY(-50%);
    right: 0%;
    transition: 0.3s;
  }
  .hidden-btn {
    top: 50%;
    transform: translateY(-50%);
    right: -174px;
    transition: 0.3s;
  }
  .hover-item {
    .on {
      display: none;
    }
    &:hover {
      .off {
        display: none;
      }
      .on {
        display: block;
      }
    }
  }
  .outer {
    position: relative;
    width: 100%;
    display: block;
    &:after {
      content: "";
      display: block;
      padding-Bottom: 100%;
    }
    .inner {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .section1 {
    background-image: url('~@/assets/images/202307/background-photo.png');
  }

  .section2 {
    .flower1 {
      @media (min-width: 768px) {
        top: -5% !important;
      }
      width: 33.333%;
        @media (min-width: 768px) {
          width: auto;
        }
      // img {
      //   width: 33.333%;
      //   @media (min-width: 768px) {
      //     width: auto;
      //   }
      // }
    }
  }
  .section3 {
    .main {
      background-image: url('~@/assets/images/202307/pic-01_1.png'), url('~@/assets/images/202307/pic-02_1.png');
      background-color: rgb(255, 242, 31);
      background-position: top right, bottom left;
      background-repeat: no-repeat;
    }

    .content {
      border-top-left-radius: 25px;
      border-top-right-radius: 25px;
      border-top: 3px solid #012861;
      border-right: 3px solid #012861;
      border-left: 3px solid #012861;
      border-bottom: 3px dashed #012861;
    }
  }
  .section4 {
    .content {
      border-bottom-left-radius: 25px;
      border-bottom-right-radius: 25px;
      // border-top: 3px dashed #012861;
      border-right: 3px solid #012861;
      border-left: 3px solid #012861;
      border-bottom: 3px solid #012861;
    }
  }
}
</style>
